import {observer} from "mobx-react";
import {Box} from "@mui/material";
import HomeSlideshow from "./HomeSlideshow/HomeSlideshow";
import ContactPage from "../Contact/ContactPage";
import HomeShopShortcut from "../ShopShortcut/ShopShortcut";
import PiginiLogo from '../../assets/img/pigini_logo_ch.jpeg';
import ExcelsiorLogo from '../../assets/img/excelsior_hr.jpeg'

export default observer(function HomePage(){
    return (
        <Box>
            <HomeSlideshow />
            <Box sx={{mt: 6}}/>
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <img src={PiginiLogo} style={{width: '200px'}}/>
            </Box>
            <Box sx={{mt: 2}}/>
            <HomeShopShortcut />
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 8}}>
                <img src={ExcelsiorLogo} style={{height: '70px'}}/>
            </Box>
            <Box sx={{mt: 8}}/>
            <ContactPage/>
        </Box>
    )
})